
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/exclusives/homes/[slug]",
      function () {
        return require("private-next-pages/exclusives/homes/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/exclusives/homes/[slug]"])
      });
    }
  